import { render, staticRenderFns } from "./website-attraction.vue?vue&type=template&id=92257d70&scoped=true"
import script from "./website-attraction.vue?vue&type=script&lang=js"
export * from "./website-attraction.vue?vue&type=script&lang=js"
import style0 from "./website-attraction.vue?vue&type=style&index=0&id=92257d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92257d70",
  null
  
)

export default component.exports